import { getLogger } from '@spotify-internal/remote-config-common';
import { KnownContext, Middleware } from '@spotify-internal/remote-config-core';
import { getDefinition, getDefinitions, Property, } from '@spotify-internal/remote-config-properties';
export const propertiesMiddleware = Middleware.fromContextProvider(({ clientId, properties }) => {
    const logger = getLogger('middleware:properties');
    let propertySetId;
    const calculatePropertySetId = (ctx) => Property.getPropertySetId({ clientId }, properties ? properties.map(getDefinition) : getDefinitions(), KnownContext.extractDeclaredIdentifiers(ctx));
    return ctx => {
        propertySetId !== null && propertySetId !== void 0 ? propertySetId : (propertySetId = calculatePropertySetId(ctx));
        logger.info('Property Set ID', propertySetId);
        return Object.assign(Object.assign({}, ctx), { propertySetId });
    };
});
//# sourceMappingURL=properties.js.map